/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MonitorState = 'CREATION_PENDING' | 'ACTIVE' | 'PAUSED' | 'DELETION_PENDING' | 'DELETED';

export const MonitorState = {

    CREATION_PENDING: 'CREATION_PENDING' as MonitorState,

    ACTIVE: 'ACTIVE' as MonitorState,

    PAUSED: 'PAUSED' as MonitorState,

    DELETION_PENDING: 'DELETION_PENDING' as MonitorState,

    DELETED: 'DELETED' as MonitorState
};

